import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const VideoEditor = ({ data, onChange }) => {
  return (
    <div className="bg-white rounded-lg p-6 space-y-6">
      <h2 className="text-2xl font-bold text-slate-900">Video Section</h2>
      
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">Section Title</label>
        <Input
          value={data.title}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          placeholder="Experience Alcarias Hills"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">Description</label>
        <Input
          value={data.description}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          placeholder="Take a virtual tour"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">Video URL (YouTube, Vimeo, or direct link)</label>
        <Input
          value={data.videoUrl}
          onChange={(e) => onChange({ ...data, videoUrl: e.target.value })}
          placeholder="https://youtube.com/watch?v=..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">Placeholder Image URL</label>
        <Input
          value={data.placeholder}
          onChange={(e) => onChange({ ...data, placeholder: e.target.value })}
          placeholder="Image URL for video placeholder"
        />
      </div>

      <p className="text-sm text-slate-500">
        Note: Video uploads are handled through the video player interface on the main site.
      </p>
    </div>
  );
};

export default VideoEditor;
